import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=3bb17593"
var script = {}
import style0 from "./Services.vue?vue&type=style&index=0&id=3bb17593&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports